
import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

interface AssignProviderModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const AssignProviderModal: React.FC<AssignProviderModalProps> = ({ 
  open, 
  onOpenChange 
}) => {
  // Mock data de proveedores globales
  const providers = [
    { id: '1', nombre: 'Fotografía Profesional SA', tipo: 'Fotografía' },
    { id: '2', nombre: 'Banquetes Los Pinos', tipo: 'Catering' },
    { id: '3', nombre: 'Flores del Valle', tipo: 'Decoración' },
    { id: '4', nombre: 'Sonido Premium', tipo: 'Audio/Video' }
  ];

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Asignar Proveedor al Evento</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <div>
            <Label htmlFor="provider">Seleccionar proveedor</Label>
            <Select>
              <SelectTrigger>
                <SelectValue placeholder="Selecciona un proveedor..." />
              </SelectTrigger>
              <SelectContent>
                {providers.map((provider) => (
                  <SelectItem key={provider.id} value={provider.id}>
                    {provider.nombre} - {provider.tipo}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
          <div>
            <Label htmlFor="descripcion">Descripción del servicio</Label>
            <Textarea 
              id="descripcion" 
              placeholder="Describe el servicio específico para este evento..."
              rows={3}
            />
          </div>
          <div>
            <Label htmlFor="precio">Precio acordado</Label>
            <Input 
              id="precio" 
              type="number"
              placeholder="0.00" 
              min="0"
              step="0.01"
            />
          </div>
          <div className="flex justify-end space-x-2 pt-4">
            <Button variant="outline" onClick={() => onOpenChange(false)}>
              Cancelar
            </Button>
            <Button className="bg-blue-600 hover:bg-blue-700 text-white">
              Asignar Proveedor
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
